import React from 'react';
import styled from 'styled-components';
import { theme, Icon } from '../../../../../ui';

export const DragHandle = styled.div`
  opacity: 0;
  transform: translateX(12px) scale(0.7);
  transition:
    opacity 0.35s ease-out,
    transform 0.35s ease-out;
  cursor: grab;
  padding: 0 4px;
  display: flex;
  align-items: center;
  pointer-events: auto;
  touch-action: none;

  &:active {
    cursor: grabbing;
    transform: translateX(0) scale(1);
  }
`;

export const MenuButton = styled.div`
  opacity: 0;
  transform: translateX(-12px) scale(0.7);
  transition:
    opacity 0.35s ease-out,
    transform 0.35s ease-out;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  margin-left: auto;

  &:hover {
    background: ${theme.colors.NEU_200};
  }

  &:active {
    transform: translateX(0) scale(1);
  }
`;

/**
 * DragHandleControl - Drag handle that appears on hover in edit mode
 */
export const DragHandleControl = ({ size = 'small', disabled = false }) => (
  <DragHandle onClick={(e) => e.stopPropagation()} style={disabled ? { visibility: 'hidden', pointerEvents: 'none' } : undefined}>
    <Icon.DragIndicator size={size} color={theme.colors.NEU_600} />
  </DragHandle>
);

/**
 * MenuButtonControl - Menu button that appears on hover in edit mode
 */
export const MenuButtonControl = ({ onClick, size = 'small' }) => (
  <MenuButton onClick={onClick}>
    <Icon.More size={size} color={theme.colors.NEU_600} />
  </MenuButton>
);
